export const ticketSchema = {
    fields: [
        {
            type: 'group',
            name: 'row2',
            children: [
                {
                    name: 'ticker',
                    label: 'Enter Your Ticker',
                    type: 'text',
                    placeholder: 'Enter ticker',
                    required: true,
                },
                {
                    name: 'stateCode',
                    label: 'Enter State',
                    type: 'text',
                    placeholder: 'Enter state',
                    required: true,
                },
            ]
        }
    ],
    buttons: [
        {
            label: 'Cancel',
            action: 'cancel',
            type: 'button',
            className: 'btn-back',
        },
        {
            label: 'Save Ticker',
            action: 'save',
            type: 'button',
            className: 'btn-next',
        },
    ],
};